"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchSuggestionsProviderImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing SearchSuggestionsProvider operations. */
var SearchSuggestionsProviderImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class SearchSuggestionsProvider class.
   * @param client Reference to the service client
   */
  function SearchSuggestionsProviderImpl(client) {
    (0, _classCallCheck2["default"])(this, SearchSuggestionsProviderImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(SearchSuggestionsProviderImpl, [{
    key: "get",
    value: function get(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getOperationSpec);
    }
  }]);
  return SearchSuggestionsProviderImpl;
}(); // Operation Specifications


exports.SearchSuggestionsProviderImpl = SearchSuggestionsProviderImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getOperationSpec = {
  path: "/api/Portals({portalId})/SearchSuggestionsProviders",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchSuggestionsProviderModel"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};